export default __webpack_public_path__ + "static/media/1.766718fd.png";